import Loadable from 'UIComponents/decorators/Loadable';
import UILayer from 'UIComponents/layer/UILayer';
import UILoadingOverlay from 'UIComponents/loading/UILoadingOverlay';
import { jsx as _jsx } from "react/jsx-runtime";
export default (loader => {
  return Loadable({
    loader,
    LoadingComponent({
      pastDelay
    }) {
      return pastDelay ? /*#__PURE__*/_jsx(UILayer, {
        children: /*#__PURE__*/_jsx("div", {
          style: {
            position: 'fixed',
            zIndex: 1211,
            top: 0,
            left: 0,
            right: 0,
            bottom: 0
          },
          children: /*#__PURE__*/_jsx(UILoadingOverlay, {})
        })
      }) : null;
    }
  });
});